export default "__VITE_ASSET__DIq0uKzg__"